import React from "react";
import { useIntl } from "react-intl";

import { genericMessages } from "src/messages/generic";

export function useFormatAge(): (dateOfBirth: string) => string {
	const { formatMessage } = useIntl();
	return React.useCallback(
		(dateOfBirth: string) => {
			if (dateOfBirth === "") {
				return "";
			}
			return formatMessage(genericMessages.yearsOfAge, {
				years: computeAge(dateOfBirth)
			});
		},
		[formatMessage]
	);
}

export function useFormatYears(): (dateOfBirth: string) => string {
	const { formatMessage } = useIntl();
	return React.useCallback(
		(dateOfBirth: string) => {
			if (!dateOfBirth) {
				return "";
			}
			return formatMessage(genericMessages.years, {
				years: computeAge(dateOfBirth)
			});
		},
		[formatMessage]
	);
}

export function computeAge(dateOfBirth: string): number {
	const d1 = new Date(dateOfBirth);

	d1.setUTCMilliseconds(0);
	d1.setUTCSeconds(0);
	d1.setUTCMinutes(0);
	d1.setUTCHours(0);

	const d2 = new Date();

	d2.setUTCMilliseconds(0);
	d2.setUTCSeconds(0);
	d2.setUTCMinutes(0);
	d2.setUTCHours(24);

	const d3 = new Date(d2.getTime() - d1.getTime());

	return Math.abs(d3.getUTCFullYear() - 1970);
}
